import type { FullParcel } from '@coig/apm-api';
import { IonCard, IonCardHeader, IonCardContent, IonIcon, IonList, IonListHeader, IonLabel, IonItem, IonButton, IonModal } from '@ionic/react';
import { chevronForwardOutline } from 'ionicons/icons';
import { states } from '../../../../utilities/states';
import { useState } from 'react';
import '../Package.css';
import { useHistory } from 'react-router';
import './PackageReceivedListElement.css';
import { DateTime} from 'luxon';
import React from 'react';

const packageReceivedListElement: React.FC<FullParcel & {ref: any}> = React.forwardRef<HTMLIonCardElement, FullParcel>(({ status, id, sender, parcelName, statusModificationTime}, cardRef) => {

  const history = useHistory();
  const [pickupScreen, setShowPickupScreen] = useState<boolean>(false);
  const [showCodeModal, setShowCodeModal] = useState<boolean>(false);

  return (
    <IonCard className={status === 'RECEIVED' ? 'taken-out' : 'ready'} ref={cardRef as any}>
      <div className='anchor'>&nbsp;</div>
      <div onClick={()=> {
        if (pickupScreen){
          setShowPickupScreen(false);
          return;
        }
        if (status === 'RECEIVED'){
          history.push(`/received-packages/take-package/${id}`);
          return;
        }
        setShowPickupScreen(true);
        return;
      }}>
        <IonCardHeader>
          <h2>Parcel: Wien Mitte Landstraße</h2>
          <h2>ID: {id}</h2>
        </IonCardHeader>
        <IonCardContent>
          <div>
            <p>Sender:</p>
            <h1>{sender?.name}</h1>
          </div>
          <div>
            <p>Name:</p>
            <h1>{parcelName}</h1>
          </div>
        </IonCardContent>
        <div className="state-bar">
          <div className="state-bar-left">
            <span>State:</span>
            <h3>{states(status, 'receiver')}</h3>
          </div>
          <div className="state-bar-right">
            {
              status !== 'RECEIVED' ?
                <>
                  <span>Time to pickup:</span>
                  <h3>48 hours</h3>
                </>:
                <>
                  <span>Last change:</span>
                  <h3 className='date-time'>{DateTime.fromISO(statusModificationTime).setLocale('en').toLocaleString(DateTime.DATETIME_SHORT)}</h3>
                </>
            }
          </div>
          <div className="state-bar-icon">
            <IonIcon icon={chevronForwardOutline} />
          </div>
        </div>
        <div className="pickup" hidden={!pickupScreen}>
          <h4>Let's pickup package:</h4>
          <div className="pickup-slider">
            <IonButton color='warning' onClick={async ()=> {
              history.push(`/received-packages/take-package/${id}`);
              navigator.vibrate(500);
            }
            }>
            Open<br/> locker<br/> now
            </IonButton>
            <span className='or'>OR</span>
            <IonModal isOpen={showCodeModal} cssClass='code-modal'>
              <h4>SCAN ME</h4>
              <img src='assets/open-qr-code-placeholder.png'></img>
              <div>
                <h5>OR ENTER CODE MANUAL</h5>
                <p>0000</p>
                <h5>PHONE NUMBER:</h5>
                <p>+48 123 456 789</p>
              </div>
              <IonButton onClick={() => setShowCodeModal(false)} expand="full">Close</IonButton>
            </IonModal>
            <img src='assets/open-qr-code-placeholder.png' onClick={() => setShowCodeModal(true)}/>
            <span className='or'>OR</span>
            <div className='pickup-phone' onClick={() => setShowCodeModal(true)}>
              <h5>Enter your number:</h5>
              <p>123 456 789</p>
              <h5>Enter code:</h5>
              <p>0000</p>
            </div>
          </div>
        </div>
      </div>
      <IonList>
        <IonListHeader>
            Additional options for package:
        </IonListHeader>

        <IonItem button lines="none">
          <IonLabel>Redirect package</IonLabel>
        </IonItem>
        <IonItem button lines="none">
          <IonLabel>Share code & QR code</IonLabel>
        </IonItem>
        <IonItem button lines="none">
          <IonLabel>Redirect package</IonLabel>
        </IonItem>
        <IonItem button lines="none">
          <IonLabel>Tracking statuses</IonLabel>
        </IonItem>
        <IonItem button lines="none">
          <IonLabel>Avaiable collect to one locker</IonLabel>
        </IonItem>
      </IonList>
    </IonCard>
  );
});

export { packageReceivedListElement as PackageReceivedListElement };
